export default "__VITE_ASSET__D3cV8Pmh__"